import { render } from "./SwitchTypeComponent.vue?vue&type=template&id=8ec82b58&scoped=true"
import script from "./SwitchTypeComponent.vue?vue&type=script&lang=js"
export * from "./SwitchTypeComponent.vue?vue&type=script&lang=js"

import "./SwitchTypeComponent.vue?vue&type=style&index=0&id=8ec82b58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec82b58"]])

export default __exports__